import api from '../api'

export default {


  create : async (visit) => {
    return api.post('api/visits',visit)
  },

}
